import { HttpInterceptorFn } from '@angular/common/http';

import { environment } from '../../environments/environment';

/**
 * Client identifier for API usage tracking.
 * Used to identify which application is making API requests.
 */
const CLIENT_ID = 'link-generator';

/**
 * Adds ApiKey and X-Client-Id headers to requests to dreampay.com.br API endpoints.
 */
export const apiKeyInterceptor: HttpInterceptorFn = (req, next) => {
  const isDreampayApi = req.url.includes('dreampay.com.br/api');

  if (isDreampayApi) {
    const headers: Record<string, string> = {
      'X-Client-Id': CLIENT_ID,
    };

    if (environment.apiKey) {
      headers['ApiKey'] = environment.apiKey;
    }

    req = req.clone({ setHeaders: headers });
  }

  return next(req);
};
